export default "__VITE_ASSET__ARYICJKQ__"